import React, { Component} from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'react-bootstrap'
import Header from '../Header'
import { key_local_storage_user } from '../../lib/backend/data'
import 'moment/locale/es';
import PlanesListado from '../../subComponents/planificador/listado'
import LotesEtiquetasListado from '../../subComponents/etiquetas/lotes_listado'
import { cerrarSesion } from '../../redux/actions/session'

class EtiquetasLotes extends Component {
    constructor(props){
        super(props)
        this.state = {
            user: JSON.parse(localStorage.getItem(key_local_storage_user))
        }
    }
    render(){
        const { user } = this.state
        return(<LotesEtiquetasListado token={user.tokenSession} condicion_default={{}} />)
    }
}

const mapStateToProps = (state) => {
    return {
        miusuario: state.miusuario
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        cerrarSesion: () => dispatch(cerrarSesion())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EtiquetasLotes);